import styled from 'styled-components';

export const TileBox = styled.div<{ size: number }>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  position: relative;
  overflow: hidden;
`;

export const TileInner = styled.div<{ size: number, mouseDown: boolean }>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  background-image: url(images/closed.svg);
  background-size: ${props => props.size}px ${props => props.size}px;
  ${props => props.mouseDown && 'background: #c6c6c6;'}
`;

export const HiddenContent = styled.div<{ count: number, size: number }>`
  position: absolute;
  top: 0; bottom: 0; left:0; right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(images/type${props => props.count}.svg);
  background-size: ${props => props.size}px ${props => props.size}px;
`;

export const Boom = styled.div<{ size: number }>`
  position: absolute;
  top: 0; bottom: 0; left:0; right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(images/mine.svg);
  background-size: ${props => props.size}px ${props => props.size}px;
`;

export const Flag = styled.div<{ size: number }>`
  background-image: url(images/flag.svg);
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  background-size: ${props => props.size}px ${props => props.size}px;
`;
